import { GameplaySystemLogger } from "./SharedGameplaySystemLogger";

export abstract class GameplaySystem extends GameplaySystemLogger {
    public abstract Initialize(): void;
    public abstract Update(deltaTimeS: number, deltaTimeMS?: number, currentTime?: Timestamp): void;
    public abstract Cleanup(): void;
}
